<template lang="pug">
  div 
    .menu(v-if="!isMobile")
      .container
        .row
          .col-xs-12.col-lg-10.col-lg-offset-1
            nav.navigation(v-fade)
              .navigation__item
                a.navigation__link.text-small.js-scroll(href="#fizzy") Коллекция Villa Blanca
              .navigation__item
                a.navigation__link.text-small.js-scroll(href="#taste-secrets") Секрет вкуса 
              .navigation__item
                a.navigation__link.text-small.js-scroll(href="#lifestyle") Жизнь в стиле Villa Blanca 
              .navigation__item
                a.navigation__link.text-small.js-scroll(href="#features") Почему Villa Blanca
              .navigation__item
                a.navigation__link.text-small.js-scroll(href="#feedback") Контакты
    .mobile-menu(v-if="isMobile")
      .mobile-menu__burger(@click="toggleMenu", ref="burger", :class="{ 'mobile-menu__burger--animate' : isMenuOpen }")
        svg(width="72" height="32" viewBox="0 0 72 32" fill="none" xmlns="http://www.w3.org/2000/svg")
          path(id="Vector" d="M39.5 28C39.5 28 45.5 31 50.5314 28.6296C55.3724 25.5463 60.3341 28.6296 60.3341 28.6296C60.3341 28.6296 65.2401 31.6479 69.9785 28.6296C71.5 27.6605 73.5 26 73.5 26M2 28.6296C2 28.6296 6.69036 31.713 11.5314 28.6296C16.3724 25.5463 21.3341 28.6296 21.3341 28.6296C21.3341 28.6296 26.2401 31.6479 30.9785 28.6296C35.7169 25.6117 41.0607 28.6296 41.0607 28.6296" stroke="url(#paint0_linear)" stroke-width="4")
          path(id="Vector_2" d="M40.5 15.5C40.5 15.5 45.6899 18.8982 50.531 15.8148C55.372 12.7315 60.3337 15.8148 60.3337 15.8148C60.3337 15.8148 65.2397 18.8331 69.9781 15.8148C71.5 14.8454 73.5 14 73.5 14M2 15.8148C2 15.8148 6.69036 18.8981 11.5314 15.8148C16.3724 12.7315 21.3341 15.8148 21.3341 15.8148C21.3341 15.8148 26.2401 18.8331 30.9785 15.8148C35.7169 12.7968 41.0607 15.8148 41.0607 15.8148" stroke="url(#paint1_linear)" stroke-width="4")
          path(id="Vector_3" d="M39 2.50001C39 2.50001 45.5 6.00001 50.5314 3.37037C55.3724 0.28704 60.3341 3.37037 60.3341 3.37037C60.3341 3.37037 65.137 5.41318 69.5 4C70.1842 3.77837 73 1.99999 73.5 1.5M2 3.37037C2 3.37037 6.69036 6.4537 11.5314 3.37037C16.3724 0.287034 21.3341 3.37037 21.3341 3.37037C21.3341 3.37037 26.2401 6.38868 30.9785 3.37037C35.7169 0.3524 41.0607 3.37037 41.0607 3.37037" stroke="url(#paint2_linear)" stroke-width="4")
          defs
            linearGradient(id="paint0_linear" x1="-83.5831" y1="42.8985" x2="-83.7054" y2="27.2549" gradientUnits="userSpaceOnUse")
              stop(stop-color="#DCCD85")
              stop(offset="0.249894" stop-color="#D3C479")
              stop(offset="0.510848" stop-color="#FFFF95")
              stop(offset="1" stop-color="#CCCDAA")
            linearGradient(id="paint1_linear" x1="-83.5831" y1="30.0837" x2="-83.7054" y2="14.4401" gradientUnits="userSpaceOnUse")
              stop(stop-color="#DCCD85")
              stop(offset="0.249894" stop-color="#D3C479")
              stop(offset="0.510848" stop-color="#FFFF95")
              stop(offset="1" stop-color="#CCCDAA")
            linearGradient(id="paint2_linear" x1="-83.5831" y1="17.6393" x2="-83.7054" y2="1.99568" gradientUnits="userSpaceOnUse")
              stop(stop-color="#DCCD85")
              stop(offset="0.249894" stop-color="#D3C479")
              stop(offset="0.510848" stop-color="#FFFF95")
              stop(offset="1" stop-color="#CCCDAA")
      .mobile-menu__panel.panel(v-if="isMenuOpen", :class="{ 'panel--open' : isMenuOpen }")
        img.panel__logo(src="../assets/logo.png" alt="Вилла Бланка")
        nav.panel__navigation.navigation
          .navigation__item
            a.navigation__link.navigation__link--hover.text-small.js-scroll(href="#fizzy", @click="toggleMenu") Коллекция Villa Blanca
          .navigation__item
            a.navigation__link.navigation__link--hover.text-small.js-scroll(href="#taste-secrets", @click="toggleMenu") Секрет вкуса 
          .navigation__item
            a.navigation__link.navigation__link--hover.text-small.js-scroll(href="#lifestyle", @click="toggleMenu") Жизнь в стиле Villa Blanca 
          .navigation__item
            a.navigation__link.navigation__link--hover.text-small.js-scroll(href="#features", @click="toggleMenu") Почему Villa Blanca
          .navigation__item
            a.navigation__link.navigation__link--hover.text-small.js-scroll(href="#feedback", @click="toggleMenu") Контакты
        .panel__bottom
          .panel__text Если у вас остались вопросы — напишите нам, мы с радостью ответим.
          a.panel__mail(href="mailto:hello@villa-blanca.ru") hello@villa-blanca.ru
          .panel__social-list.social-list
            a.panel__social.social-list__item(href="https://vk.com/villablancaart", target="_blank")
              img(src="~@/assets/vk-gradient.svg")
            a.panel__social.social-list__item(href="https://www.instagram.com/villablancaart/", target="_blank")
              img(src="~@/assets/insta-gradient.svg")
            a.panel__social.social-list__item(href="https://www.facebook.com/villablancaart", target="_blank")
              img(src="~@/assets/fb-gradient.svg")
        .panel__close(@click="toggleMenu")
          img(src="~@/assets/close.svg", alt="Закрыть меню")

</template>

<script>
export default {
  name: "Navigation",
  data() {
    return {
      isMenuOpen: false,
      isMobile: false,
      defaultSpeed: 1000,
    };
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 1200;
      this.isMenuOpen = window.innerWidth >= 1200;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      document.documentElement.classList.toggle("no-scroll");
    },
    closeMenu() {
      this.isMenuOpen = false;
    }
  },
  mounted() {
    var self = this;

    this.$nextTick(() => {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();

      function smoothScrollToAnchors() {
        if (
          "querySelector" in document &&
          "addEventListener" in window &&
          Array.prototype.forEach
        ) {
          var smoothScroll = function(anchor, duration) {
            var startLocation = window.pageYOffset;
            var endLocation = anchor.offsetTop;
            var distance = endLocation - startLocation;
            var increments = distance / (duration / 16);
            var stopAnimation;

            var animateScroll = function() {
              window.scrollBy(0, increments);
              stopAnimation();
            };

            if (increments >= 0) {
              stopAnimation = function() {
                var travelled = window.pageYOffset;
                if (
                  travelled >= endLocation - increments ||
                  window.innerHeight + travelled >= document.body.offsetHeight
                ) {
                  clearInterval(runAnimation);
                }
              };
            } else {
              stopAnimation = function() {
                var travelled = window.pageYOffset;
                if (travelled <= (endLocation || 0)) {
                  clearInterval(runAnimation);
                }
              };
            }

            var runAnimation = setInterval(animateScroll, 16);
          };

          var scrollToggle = document.querySelectorAll(".js-scroll");

          [].forEach.call(scrollToggle, function(toggle) {
            toggle.addEventListener(
              "click",
              function(e) {
                e.preventDefault();

                var dataID = toggle.getAttribute("href");
                var dataTarget = document.querySelector(dataID);
                var dataSpeed = toggle.getAttribute("data-speed");

                if (dataTarget) {
                  smoothScroll(dataTarget, dataSpeed || self.defaultSpeed);
                }
              },
              false
            );
          });
        }
      }
      smoothScrollToAnchors();
    });
  }
};
</script>

<style lang="scss">
@import "../styles/main.scss";

.menu {
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 0.0001) 0%,
    rgba(0, 0, 0, 0.211158) 56.99%,
    rgba(0, 0, 0, 0.45766) 99.88%
  );
}
.navigation {
  padding: 30px 0 47px;
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;
  align-items: center;

  @include from("xl") {
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: unset;
  }
  &__link {
    display: block;
    text-decoration: none;
    color: $color-text--contrast;
    font-weight: bold;
    padding: 0 15px;
    position: relative;

    &:after {
      content: "";
      width: 93%;
      height: 7px;
      position: absolute;
      bottom: -30%;
      left: 5px;
      background: url("~@/assets/menu-hover.svg") repeat-x;
      transform: translateY(50%);
      opacity: 0;
      transition: $menu-link-transition;
    }

    &:hover,
    &--hover {
      &:after {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}

.mobile-menu {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  &__burger {
    width: 43px;
    height: 32px;
    margin: 30px 32px 0 auto;
    overflow: hidden;
    cursor: pointer;

    path {
      stroke-dasharray: 43;
    }

    &--animate {
      path {
        animation: burgerAnimation 0.8s ease-in-out forwards;
      }
    }
  }
}

.panel {
  position: fixed;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-around;
  align-items: center;
  opacity: 0;
  transition: 0.5s ease-in-out;

  &--open {
    transition: opacity 0.5s 1s ease-in-out;
    animation: panelAnimaiton 0.5s 1s ease-in-out forwards;
  }
  &__logo {
    width: 288px;
    opacity: 0;
    animation: popupTextAnimation 0.5s 1s cubic-bezier(0, 0.01, 0, 1) forwards;
  }
  &__navigation {
    padding: 0;

    .navigation__item {
      margin-bottom: 15px;
      opacity: 0;
      animation: popupTextAnimation 0.5s 1.1s cubic-bezier(0, 0.01, 0, 1)
        forwards;

      &:last-of-type {
        margin-bottom: 0;
      }

      @media screen and (min-height: 600px) {
        margin-bottom: 45px;
      }
    }
  }
  &__bottom {
    text-align: center;
  }
  &__text {
    font-size: 14px;
    line-height: 1.1;
    color: $color-text--contrast;
    max-width: 275px;
    margin: 0 auto 32px;
    opacity: 0;
    animation: popupTextAnimation 0.5s 1.2s cubic-bezier(0, 0.01, 0, 1) forwards;
  }
  &__mail {
    font-family: $font-fmbolyarpro;
    font-size: 20px;
    line-height: 1.3;
    text-decoration: none;
    color: $color-text--contrast;
    margin-bottom: 25px;
    opacity: 0;
    animation: popupTextAnimation 0.5s 1.3s cubic-bezier(0, 0.01, 0, 1) forwards;
  }
  &__social {
    opacity: 0;
    animation: popupTextAnimation 0.5s 1.4s cubic-bezier(0, 0.01, 0, 1) forwards;
  }
  &__close {
    position: absolute;
    top: 36px;
    right: 37px;
  }
}

@keyframes burgerAnimation {
  99% {
    stroke-dashoffset: -40;
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes panelAnimaiton {
  to {
    opacity: 1;
  }
}
</style>
